module.exports = __webpack_public_path__ + "static/media/riddles-in-the-dark.13393d44.png";